exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statement-report-page[data-v-f401599c]{background:#f5f7fb}.page-toolbar[data-v-f401599c]{border-radius:6px 6px 0 0}.report-row[data-v-f401599c]:hover{background:#f8fbff}.summary-row[data-v-f401599c]{background:#f5f5f5!important}.summary-row td[data-v-f401599c]{font-weight:700}@media (max-width:960px){.statement-report-page[data-v-f401599c]{overflow-x:hidden}}", ""]);

// exports
